import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckIcon } from "lucide-react";
import { diagnosisItems } from "../../data/sections";
import { SectionHeading } from "../ui/SectionHeading";
import { LinkButton } from "../ui/Buttons";
export function Diagnosis() {
  const [selected, setSelected] = useState<string[]>([]);
  const toggle = (id: string) => setSelected(prev => prev.includes(id) ? prev.filter(s => s !== id) : [...prev, id]);
  const chosen = diagnosisItems.filter(d => selected.includes(d.id));
  return <section id="diagnostico" aria-labelledby="diagnostico-title" className="scroll-mt-20 py-20 md:py-28" data-id="element-60" data-mp="1lj4tt3ase7v0">
      <div className="mx-auto max-w-6xl px-4 md:px-6" data-id="element-61" data-mp="1vbatz0b6zvla">
        <SectionHeading id="diagnostico-title" title="¿Te pasa esto cuando intentás aprender japonés?" intro="Marcá las situaciones que te resultan conocidas y mirá qué parte del megapack apunta a cada una." data-id="element-62" data-mp="1vasrhlxxsl4x" />
        <div className="mt-12 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-63" data-mp="5c09bemfqmrv">
          {diagnosisItems.map(item => {
          const active = selected.includes(item.id);
          return <button key={item.id} type="button" aria-pressed={active} onClick={() => toggle(item.id)} className={`flex items-start gap-3 rounded-2xl border p-5 text-left transition-[background-color,border-color] duration-150 ease-out ${active ? "border-terracota bg-sakura-light" : "border-pizarra/15 bg-papel hover:border-pizarra/40"}`} data-id="element-64" data-mp="3rjhxnkjzg0k3">
                <span className={`mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-md border transition-colors duration-150 ${active ? "border-terracota-deep bg-terracota-deep text-papel" : "border-pizarra/30 bg-marfil"}`} aria-hidden="true" data-id="element-65" data-mp="abwdbdv4ue7f">
                  {active && <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-66" data-mp="2wchccotulqua" />}
                </span>
                <span className="text-[17px] font-medium leading-snug text-pizarra-deep" data-id="element-67" data-mp="31bk8fjruomq4">{item.label}</span>
              </button>;
        })}
        </div>
        <div aria-live="polite" className="mt-8" data-id="element-68" data-mp="2rid6k8wbjous">
          <AnimatePresence initial={false} data-id="element-69" data-mp="2djwqvsghao0i">
            {chosen.length > 0 && <motion.div initial={{
            opacity: 0,
            y: 8
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: 8
          }} transition={{
            duration: 0.2,
            ease: [0.23, 1, 0.32, 1]
          }} className="rounded-3xl border border-pizarra/10 bg-crema/60 p-6 md:p-8" data-id="element-70" data-mp="2dlzmcs0eh9cm">
                <p className="font-serif text-xl text-pizarra-deep md:text-2xl" data-id="element-71" data-mp="1u45rvh0ur9q">Dónde encontrás cada respuesta</p>
                <ul className="mt-5 divide-y divide-pizarra/10" data-id="element-72" data-mp="6se2wbmb41xz">
                  {chosen.map(c => <li key={c.id} className="grid gap-1 py-4 md:grid-cols-[260px_1fr] md:gap-6" data-id="element-73" data-mp="1rc9gzuy13cy2">
                      <p className="text-sm font-semibold text-terracota-deep" data-id="element-74" data-mp="1mdpqdh8hpczd">{c.reference}</p>
                      <p className="text-pizarra" data-id="element-75" data-mp="2122r0riivk07">{c.response}</p>
                    </li>)}
                </ul>
                <p className="mt-2 text-xs text-pizarra-soft" data-id="element-76" data-mp="1w8hocm5zi1uo">Orientación general, no una evaluación de nivel.</p>
              </motion.div>}
          </AnimatePresence>
        </div>
        <div className="mx-auto mt-12 max-w-2xl text-center" data-id="element-77" data-mp="2604b9froppd9">
          <p className="font-serif text-2xl leading-snug text-pizarra-deep md:text-3xl" data-id="element-78" data-mp="2jz3xkgrq5s69">
            No necesitás seguir acumulando pestañas. Necesitás saber qué estudiar y cómo practicarlo.
          </p>
          <LinkButton href="#sistema" variant="secondary" withArrow className="mt-7" data-id="element-79" data-mp="pn70o8aiju3t">
            Ver cómo está organizado
          </LinkButton>
        </div>
      </div>
    </section>;
}